import { render, staticRenderFns } from "./RequestsAnalytic.vue?vue&type=template&id=8d1fad6c&scoped=true&"
import script from "./RequestsAnalytic.vue?vue&type=script&lang=js&"
export * from "./RequestsAnalytic.vue?vue&type=script&lang=js&"
import style0 from "./RequestsAnalytic.vue?vue&type=style&index=0&id=8d1fad6c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d1fad6c",
  null
  
)

export default component.exports